import React from 'react';
import ContactForm from '../components/ContactForm';

export default function ContactPage() {
  const googleMapsUrl =
    'https://maps.google.com/?cid=9804199658367035339&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAMYASAF&hl=da-DK&source=embed';

  return (
    <>
      <title>Kontakt | rolskov-bowtech.dk</title>
      <meta
        name="description"
        content="Kontakt Rolskov Bowtech i Skårup på Fyn. Ring på 27 11 75 57 eller send en e-mail for spørgsmål og tidsbestilling."
      />
      <link rel="canonical" href="https://rolskov-bowtech.dk/contact" />

      {/* Header Banner */}
      <section className="bg-[#f4efe6]/60 py-12 lg:py-16 border-b border-[#228A47]/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-4">
          <span className="text-xs font-semibold text-[#228A47] uppercase tracking-wider bg-[#e8f5ed] px-3 py-1 rounded-full">
            Tidsbestilling &amp; Spørgsmål
          </span>
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#062364]">
            Kontakt Rolskov Bowtech
          </h1>
          <p className="text-base sm:text-lg text-[#132038] max-w-3xl leading-relaxed">
            Du er altid velkommen til at kontakte Jørn Rolskov direkte for aftale eller spørgsmål vedrørende Bowtech.
          </p>
        </div>
      </section>

      {/* Contact Main Content */}
      <section className="py-16 bg-[#faf8f5]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-12">
          
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-start">
            
            {/* Left Column: Direct Info & Quick CTAs */}
            <div className="lg:col-span-5 space-y-6">
              
              <div className="bg-white p-8 rounded-3xl border border-[#228A47]/15 shadow-xs space-y-6">
                <div className="border-b border-[#f4efe6] pb-4">
                  <h2 className="text-2xl font-bold text-[#062364]">
                    Klinikoplysninger
                  </h2>
                  <p className="text-xs text-slate-500 mt-1">
                    Rolskov Bowtech · Jørn Rolskov
                  </p>
                </div>

                <div className="space-y-4 text-sm text-[#132038]">
                  <div className="flex items-start gap-3.5">
                    <div className="w-9 h-9 rounded-xl bg-[#e8f5ed] text-[#228A47] flex items-center justify-center shrink-0">
                      <i className="fa-regular fa-user" aria-hidden="true"></i>
                    </div>
                    <div>
                      <p className="text-xs font-semibold text-slate-400 uppercase">Behandler</p>
                      <p className="font-bold text-[#062364]">Jørn Rolskov</p>
                      <p className="text-xs text-slate-600">Bowtechbehandler</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-3.5">
                    <div className="w-9 h-9 rounded-xl bg-[#e8f5ed] text-[#228A47] flex items-center justify-center shrink-0">
                      <i className="fa-regular fa-location-dot" aria-hidden="true"></i>
                    </div>
                    <div>
                      <p className="text-xs font-semibold text-slate-400 uppercase">Adresse</p>
                      <p className="font-bold text-[#062364]">Østergade 47</p>
                      <p className="text-xs text-slate-600">5881 Skårup Fyn, Danmark</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-3.5">
                    <div className="w-9 h-9 rounded-xl bg-[#e8f5ed] text-[#228A47] flex items-center justify-center shrink-0">
                      <i className="fa-regular fa-phone" aria-hidden="true"></i>
                    </div>
                    <div>
                      <p className="text-xs font-semibold text-slate-400 uppercase">Telefon</p>
                      <a
                        href="tel:27117557"
                        className="whitespace-nowrap font-bold text-[#062364] hover:text-[#228A47] transition-colors"
                      >
                        27 11 75 57
                      </a>
                    </div>
                  </div>

                  <div className="flex items-start gap-3.5">
                    <div className="w-9 h-9 rounded-xl bg-[#e8f5ed] text-[#228A47] flex items-center justify-center shrink-0">
                      <i className="fa-regular fa-envelope" aria-hidden="true"></i>
                    </div>
                    <div>
                      <p className="text-xs font-semibold text-slate-400 uppercase">E-mail</p>
                      <a
                        href="mailto:joern@rolskov-bowtech.dk"
                        className="whitespace-nowrap font-bold text-[#062364] hover:text-[#228A47] transition-colors"
                      >
                        joern@rolskov-bowtech.dk
                      </a>
                    </div>
                  </div>
                </div>

                {/* Big Action Buttons */}
                <div className="pt-2 flex flex-col gap-3">
                  <a
                    href="tel:27117557"
                    className="whitespace-nowrap w-full py-3.5 px-4 text-center text-sm font-semibold text-white bg-[#228A47] hover:bg-[#1b713a] rounded-xl shadow-xs transition-colors flex items-center justify-center gap-2"
                  >
                    <i className="fa-solid fa-phone" aria-hidden="true"></i>
                    <span>Ring til Jørn</span>
                  </a>

                  <a
                    href="mailto:joern@rolskov-bowtech.dk"
                    className="whitespace-nowrap w-full py-3.5 px-4 text-center text-sm font-semibold text-[#062364] bg-[#f4efe6] hover:bg-[#e8f5ed] rounded-xl transition-colors flex items-center justify-center gap-2"
                  >
                    <i className="fa-regular fa-envelope text-[#228A47]" aria-hidden="true"></i>
                    <span>Send en e-mail</span>
                  </a>

                  <a
                    href={googleMapsUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="whitespace-nowrap w-full py-3.5 px-4 text-center text-sm font-semibold text-[#062364] bg-white border border-[#228A47]/20 hover:bg-[#e8f5ed] rounded-xl transition-colors flex items-center justify-center gap-2"
                  >
                    <i className="fa-regular fa-map-location-dot text-[#228A47]" aria-hidden="true"></i>
                    <span>Find vej i Google Maps</span>
                  </a>
                </div>

              </div>

              {/* Map Preview Card */}
              <div className="bg-white rounded-3xl p-4 border border-[#228A47]/15 shadow-xs overflow-hidden">
                <div className="rounded-2xl overflow-hidden relative h-56 bg-slate-100 border border-slate-200">
                  <iframe
                    title="Kort over Rolskov Bowtech i Skårup"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2268.324!2d10.6888!3d55.0944!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x464ce5f1e8f!2s%C3%98stergade%2047%2C%205881%20Sk%C3%A5rup%20Fyn!5e0!3m2!1sda!2sdk!4v1620000000000!5m2!1sda!2sdk"
                    className="w-full h-full border-0"
                    loading="lazy"
                    allowFullScreen=""
                  ></iframe>
                </div>
              </div>

            </div>

            {/* Right Column: Contact Form */}
            <div className="lg:col-span-7">
              <ContactForm />
            </div>

          </div>

        </div>
      </section>
    </>
  );
}
